export const AUTH_TOKEN_COOKIE = "tms_token";
export const LOGIN_PATH = "/login";
export const START_PATH = "/chat";
export const NOT_FOUND_ROUTE_NAME = "not-found";
export const REDIRECT_QUERY_PARAM = "redirect";
export const SIGN_OUT_REASON_QUERY_PARAM = "reason";
export const NON_RETURNABLE_PATHS = ["/", "/login", "/reset-password", "/change-password", "/dashboard", "/chat"];
